import React, {useState} from 'react';
import clsx from 'clsx';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import ListItemText from '@material-ui/core/ListItemText';
import Select from '@material-ui/core/Select';
import Checkbox from '@material-ui/core/Checkbox';
import Chip from '@material-ui/core/Chip';
import { useTranslation } from 'react-i18next';

// Make sure moment.js has the required locale data
import 'moment/locale/es';
import 'moment/locale/ca';

const useStyles = makeStyles(theme => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
        maxWidth: 300,
        width: '100%'
    },
    chips: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    chip: {
        margin: 2,
    },
    noLabel: {
        marginTop: theme.spacing(3),
    },
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};



function getStyles(name, personName, theme) {
    return {
        fontWeight:
            personName.indexOf(name) === -1
                ? theme.typography.fontWeightRegular
                : theme.typography.fontWeightMedium,
    };
}

export default function MultipleSelect(props) {
    const classes = useStyles();
    const theme = useTheme();
    const [personName, setPersonName] = React.useState([]);
    const { t, i18n } = useTranslation();
    const [locale, setLocale] = useState('en');
    const [openSelect, setOpenSelect] = React.useState(false);
    const handleChange = event => {
        props.setFiltroLineas(event.target.value);

        setOpenSelect(false)
    };
    const handleClose = () => {


        setOpenSelect(false);
    };

    const handleOpen = () => {
        setOpenSelect(true);
    };

    return (
        <div>


            <FormControl variant="filled"  className={classes.formControl}>
                <InputLabel id={props.id3}>{t('lin')}</InputLabel>
                <Select
                    labelId={props.id3}
                    id={props.id1}
                    open={openSelect}
                    multiple
                    value={props.filtroLineas}
                    onChange={handleChange}
                    onClose={handleClose}
                    onOpen={handleOpen}
                    input={<Input id={props.id2} />}
                    renderValue={selected => (
                        <div >
                            {selected.map(value => (
                                <Chip key={value} label={value} className={classes.chip} />
                            ))}
                        </div>
                    )}
                    MenuProps={MenuProps}
                >
                    {[t('energia'),t('excedent'),t('eneta'),t('eexportada')].map(name => (
                        <MenuItem key={name} value={name} >
                            {name}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>

        </div>
    );
}
